module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Shirt-dd435062cf77aa66b93c10062f6adb03.svg";